/* Veilmoor — comportamentos minimos. Nada aqui e obrigatorio para a pagina vender:
   o carrinho e do Horizon (product-form-component), o trilho e scroll-snap em CSS. */
(function () {
  'use strict';

  /* Barra de avisos: "N days left" ate o cutoff, sem rebuild diario.
     <span data-gr-cutoff="2026-10-20" data-gr-dias></span> */
  function cutoff() {
    document.querySelectorAll('[data-gr-cutoff]').forEach(function (el) {
      var alvo = new Date(el.getAttribute('data-gr-cutoff') + 'T23:59:59');
      var dias = Math.ceil((alvo - new Date()) / 86400000);
      var out = el.querySelector('[data-gr-dias]') || el;
      if (dias > 1) out.textContent = dias + ' days left';
      else if (dias === 1) out.textContent = 'Last day';
      else out.textContent = 'Express only';
    });
  }

  /* Setas dos trilhos (reviews): <button data-gr-rolar="#id" data-dir="1"> */
  function setas() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gr-rolar]');
      if (!b) return;
      var trilho = document.querySelector(b.getAttribute('data-gr-rolar'));
      if (!trilho) return;
      var passo = (trilho.firstElementChild ? trilho.firstElementChild.getBoundingClientRect().width : 320) + 16;
      trilho.scrollBy({ left: passo * Number(b.getAttribute('data-dir') || 1), behavior: 'smooth' });
    });
  }

  function boot() { cutoff(); setas(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
